import { useCallback, useState } from "react";
import QUESTIONS from "../questions"
import Question from "./Question";
import Summary from "./Summary";


export default function Quiz()
{
    
    const [userAnswers,setUserAnswers] = useState([]);
    
    const activeQuestionIndex =  userAnswers.length;
    const quizIsCompleted = activeQuestionIndex === QUESTIONS.length;
    
    const handleSelectAnswer = useCallback(function handleSelectAnswer(selectedAnswer)
    {
        setUserAnswers((prevAnswers) => {
            return [...prevAnswers, selectedAnswer]
        })
    },[]);
    
    const onTimeout = useCallback(() => handleSelectAnswer(null),[handleSelectAnswer])
    if( quizIsCompleted )
    {
        return <Summary userAnswers={userAnswers}/>
    }
    
    return (
        <div id="quiz">
            <Question 
              key={activeQuestionIndex}
              index={activeQuestionIndex}
              onSelectAnswer={handleSelectAnswer}
              onTimeout={onTimeout}
            />
        </div>
    );
}